export default __webpack_public_path__ + "static/media/exploded-view_labels.eff6cd38.png";